import { encodeBase64 } from "../../modules/shared-utils/base64";

export const createDRMErrorXHTML = (
  error: string
) => `<?xml version="1.0" encoding="UTF-8"?>
<html xmlns="http://www.w3.org/1999/xhtml">
<head><title>Error</title></head>
<body>${error}</body>
</html>`;

const encoder = new TextEncoder();

export const makeOfflineChecksum = async (data: string) =>
  encodeBase64(
    await crypto.subtle.digest("SHA-1", encoder.encode(`8juQiA|${data}`))
  );
